import types from './types';

export default {
  getCRETeamList: () => ({
    type: types.GET_CRE_TEAM_LIST_REQUESTED,
  }),
  getCRETeamListFailed: (error) => ({
    type: types.GET_CRE_TEAM_LIST_FAILED,
    error,
  }),
  getCRETeamListSucceeded: (data) => ({
    type: types.GET_CRE_TEAM_LIST_SUCCEEDED,
    data,
  }),
};
